# Exercice & jeu : activité pour chaque animal

Le mouvement préserve les articulations, aide à gérer le poids et réduit le stress. La régularité compte plus que l’intensité, alors créez des habitudes que votre animal aime.

<ArticleImage
  src="https://images.unsplash.com/photo-1650633907713-e0a619c1a69a?q=80&w=1633&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  alt="Personne marchant dehors"
  caption="Les promenades quotidiennes sont une base simple et efficace."
/>

---

<Section emoji="🚶" title="Le mouvement au quotidien">

<Tip label="Promenades olfactives" text="Laissez du temps pour sentir et explorer — c’est aussi une stimulation mentale." />
<Tip label="Options en intérieur" text="Jeux de lancer, tirage ou courtes séances d’entraînement les jours de pluie." />
<Tip label="Régularité" text="Visez des horaires similaires chaque jour pour installer la routine." />

</Section>

<ArticleImage
  src="https://images.unsplash.com/photo-1629898452932-07074d3f9944?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  alt="Matériel d’exercice"
  caption="Renforcement et équilibre gardent l’animal agile et confiant."
/>

<Section emoji="🧠" title="Jeu qui stimule le cerveau">

<Tip label="Jouets distributeurs" text="Les puzzles alimentaires réduisent l’ennui et occupent l’esprit." />
<Tip label="Mini‑séances" text="Cinq minutes de “assis”, “reste” ou cible suffisent." />
<Tip label="Rotation des jouets" text="Alternez les jouets chaque semaine pour garder l’intérêt." />

</Section>

<ArticleImage
  src="/images/guide/exercise-goat.jpg"
  alt="Piscine"
  caption="Les activités à faible impact sont idéales pour les seniors et la convalescence."
/>

<Section emoji="🧬" title="Âge, race et santé">

<Tip label="Chiots & chatons" text="Jeux courts et fréquents plutôt que longues sessions intenses." />
<Tip label="Seniors" text="Promenades douces et surfaces souples pour ménager les articulations." />
<Tip label="Races brachycéphales" text="Évitez la chaleur et l’effort intense ; surveillez la respiration." />

</Section>

<Section emoji="🌦️" title="Sécurité & météo">

<Tip label="Hydratation" text="Apportez de l’eau et faites des pauses par temps chaud." />
<Tip label="Sol chaud" text="Si c’est trop chaud pour votre main, c’est trop chaud pour les pattes." />
<Tip label="Récupération" text="Les jours de repos font partie du plan." />

</Section>

<Disclaimer title="⚠️ Petit rappel">
Ce guide est éducatif et ne remplace pas un avis vétérinaire. Si votre animal boite, tousse ou semble très fatigué après l’activité, consultez votre vétérinaire.
</Disclaimer>
